module.exports = __webpack_public_path__ + "img/logo.2bf9c804.png";